import React, { useEffect, useState } from 'react';
import './UserDetails.css';
import { SideMenuBar } from '../../SideMenu';
import { NewHeader } from '../../NewHeader';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_URL } from '../../Config';
import axios from 'axios';


const UsersDetails = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const userDetails = location.state?.userDetails || null;

  const [formData, setFormData] = useState({

    username: userDetails.username || '',
    mobile: userDetails.mobile || '',
    email: userDetails.email || '',
    role: userDetails.role || '',
    address: userDetails.address || '',
    date_of_birth: userDetails.date_of_birth || '',
    blood_group: userDetails.blood_group || '',
    id_proof: userDetails.id_proof || '',
    id_proof_number: userDetails.id_proof_number || '',
    work_type: userDetails.work_type || '',
    previous_work: userDetails.previous_work || '',
    previous_work_with: userDetails.previous_work_with || '',
    reference_name: userDetails.reference_name || '',
    password: userDetails.password || '',
    confirm_password: userDetails.confirm_password || '',
    total_task_count: userDetails.total_task_count || '',
    total_distance_count: userDetails.total_distance_count || '',
    total_present_days_count: userDetails.total_present_days_count || '',
    total_absent_days_count: userDetails.total_absent_days_count || '',
    uuId: userDetails.uuId || '',
    manager: userDetails.manager || '',
    punch_In: userDetails.punch_In || '',
    punch_out: userDetails.punch_out || '',
    total_hour: userDetails.total_hour || '',
    profile: userDetails.profile || '',
    date_of_join: userDetails.date_of_join || '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const [users, setUsers] = useState([]);
  useEffect(() => {
    fetch(API_URL + '/users')
      .then(response => response.json())
      .then(data => setUsers(data))
      .catch(error => console.error(error));
  }, []);

  let work_type_data;
  let role_data;
  let manager_data;
  if(users && users.length > 0) {
    work_type_data = users.map(user => user.work_type).filter((value, index, self) => self.indexOf(value) === index);
    role_data = users.map(user => user.role).filter((value, index, self) => self.indexOf(value) === index);
    manager_data = users.map(user => user.manager).filter((value, index, self) => self.indexOf(value) === index);
  }

  const updateTask = async () => {
    try {
      const response = await axios.put(API_URL + `/user/${userDetails.username}`, formData);

      if (response.status === 200) {
        console.log('User updated successfully');
        window.alert('User updated successfully!')
        navigate('/EmployeeDatabase')
      } else {
        console.error('Error updating user');
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="user_details_page">
      <SideMenuBar />

      <div className="content">
        <NewHeader />

        <main className="user_details_container">
          <section className="user_details_hero">
            <div>
              <span className="user_details_kicker">People management</span>
              <h1 className="users">User Details</h1>
              <p className="user_details_subtitle">
                Review and update personal information, work access and monthly activity.
              </p>
            </div>
            <div className="user_identity">
              <span>Current user</span>
              <strong>{formData.username || 'Unnamed user'}</strong>
              <small>{formData.role || 'Role not assigned'}</small>
            </div>
          </section>

          <form className="user_details_panel" onSubmit={(e) => { e.preventDefault(); updateTask(); }}>
            <header className="user_details_panel_header">
              <div>
                <span className="section_eyebrow">Profile</span>
                <h2>Account information</h2>
              </div>
              <span className="user_status_badge">Editable</span>
            </header>

            <div className="user_details_form">
              <section className="user_details_section">
                <div className="user_details_section_heading">
                  <span className="user_section_number">01</span>
                  <div><h3>Personal information</h3><p>Contact and identity information for this employee.</p></div>
                </div>

                <div className="user_details_grid">
                  <div className="user_details_field"><label>Full Name</label><input placeholder="Enter full name" name="username" value={formData.username} onChange={handleInputChange} /></div>
                  <div className="user_details_field"><label>Phone No.</label><input placeholder="Enter phone number" name="mobile" value={formData.mobile} onChange={handleInputChange} /></div>
                  <div className="user_details_field"><label>Email ID</label><input type="email" placeholder="Enter email address" name="email" value={formData.email} onChange={handleInputChange} /></div>
                  <div className="user_details_field"><label>Blood Group</label><input placeholder="Enter blood group" name="blood_group" value={formData.blood_group} onChange={handleInputChange} /></div>
                  <div className="user_details_field user_details_field_full"><label>Current Address</label><textarea placeholder="Enter current address" name="address" value={formData.address} onChange={handleInputChange} /></div>
                  <div className="user_details_field user_details_field_full"><label>Permanent Address</label><textarea placeholder="Enter permanent address" /></div>
                  <div className="user_details_field"><label>Identity Proof Number</label><input placeholder="Enter identity proof number" name="id_proof_number" value={formData.id_proof_number} onChange={handleInputChange} /></div>
                  <div className="user_upload_field">
                    <label>Identity Proof</label>
                    <a className="a_of_uploadHere_UserDetails" href="/">
                      <img src="../assets/cloud_upload.png" alt="" />
                      <span>Upload identity proof</span><small>.jpg / .png</small>
                    </a>
                  </div>
                </div>
              </section>

              <div className="user_details_divider" />

              <section className="user_details_section">
                <div className="user_details_section_heading">
                  <span className="user_section_number">02</span>
                  <div><h3>Work &amp; access</h3><p>Role, reporting and account access settings.</p></div>
                </div>

                <div className="user_details_grid">
                  <div className="user_details_field">
                    <label>Work Type</label>
                    <select name="work_type" value={formData.work_type} onChange={handleInputChange}>
                      <option value="" disabled>Select work type</option>
                      {(work_type_data || []).map((workType, index) => <option key={index} value={workType}>{workType}</option>)}
                    </select>
                  </div>
                  <div className="user_details_field">
                    <label>Role</label>
                    <select name="role" value={formData.role} onChange={handleInputChange}>
                      <option value="" disabled>Select role</option>
                      {(role_data || []).map((role, index) => <option key={index} value={role}>{role}</option>)}
                    </select>
                  </div>
                  <div className="user_details_field">
                    <label>Manager</label>
                    <select name="manager" value={formData.manager} onChange={handleInputChange}>
                      <option value="" disabled>Select manager</option>
                      {(manager_data || []).map((manager, index) => <option key={index} value={manager}>{manager}</option>)}
                    </select>
                  </div>
                  <div className="user_details_field"><label>User ID</label><input placeholder="Enter user ID" name="uuId" value={formData.uuId} onChange={handleInputChange} /></div>
                  <div className="user_details_field"><label>Password</label><input type="password" placeholder="Enter password" name="password" value={formData.password} onChange={handleInputChange} /></div>
                  <div className="user_details_field"><label>Confirm Password</label><input type="password" placeholder="Confirm password" name="confirm_password" value={formData.confirm_password} onChange={handleInputChange} /></div>
                  <div className="user_location_link user_details_field_full"><a href="/">View current location <span>→</span></a></div>
                </div>
              </section>

              <div className="user_details_divider" />

              <section className="user_details_section">
                <div className="user_details_section_heading">
                  <span className="user_section_number">03</span>
                  <div><h3>Monthly activity</h3><p>Read-only performance indicators for the current user.</p></div>
                </div>

                <div className="user_metrics_grid">
                  <div className="user_metric"><span>Total Tasks</span><strong>{userDetails.total_task_count || '0'}</strong><small>Monthly</small></div>
                  <div className="user_metric"><span>Total Distance</span><strong>{userDetails.total_distance_count || '0'}</strong><small>Monthly</small></div>
                  <div className="user_metric"><span>Days Present</span><strong>{userDetails.total_present_days_count || '0'}</strong><small>Monthly</small></div>
                  <div className="user_metric"><span>Days Absent</span><strong>{userDetails.total_absent_days_count || '0'}</strong><small>Monthly</small></div>
                  <div className="user_metric"><span>Hours Worked</span><strong>{userDetails.total_hour || '0'}</strong><small>Monthly</small></div>
                </div>
              </section>
            </div>

            <footer className="user_details_form_footer">
              <span>Changes will be saved to this user record.</span>
              <button type="submit" className="update_btn_input_UserDetails">Save changes</button>
            </footer>
          </form>
        </main>
      </div>
    </div>
  );
};

export default UsersDetails;